import styled from "@emotion/styled";
import Link from "metabase/core/components/Link";
import { alpha, color } from "metabase/lib/colors";
export const AdminNavLink = styled(Link)`
  padding: 0.5rem 1rem;
  text-decoration: none;
  color: ${(props) => props.isSelected ? color("white") : alpha("white", 0.63)};
`;
